import React from 'react';
import { Circle } from 'lucide-react';
import { cn } from '../../lib/utils';
import { DEFAULT_BRANDING } from './visualizationConstants';

export const BrandingPreview = ({ branding }) => {
  const showIcons = branding.display_style !== 'bullets';
  const pc = branding.primary_color || '#8b5cf6';
  const sc = branding.secondary_color || '#c4b5fd';
  const tc = branding.text_color || undefined;
  const bg = branding.background_color || undefined;
  const lineConfig = branding.line_config || DEFAULT_BRANDING.line_config;
  const logoJustify = branding.logo_position === 'center' ? 'justify-center' : branding.logo_position === 'right' ? 'justify-end' : 'justify-start';

  const items = [
    { title: 'Release v2.0', level: 1 },
    { title: 'User Dashboard', level: 2 },
    { title: 'Analytics API', level: 3 },
  ];

  return (
    <div className="rounded-lg border p-3 space-y-1" style={{ backgroundColor: bg || 'var(--card)', borderColor: 'var(--border)' }} data-testid="branding-preview">
      {branding.logo_url && (
        <div className={cn("flex mb-2", logoJustify)}>
          <img src={branding.logo_url} alt="Logo" className="h-5 w-auto" />
        </div>
      )}
      {items.map((item, i) => {
        const lc = lineConfig.find(c => c.level === item.level) || { enabled: true, style: 'dashed' };
        return (
          <div key={i} className="flex items-center gap-2" style={{ paddingLeft: `${item.level * 12}px` }}>
            {i > 0 && lc.enabled && (
              <div className="w-px h-3 -mt-4 flex-shrink-0" style={{ borderLeft: lc.style === 'dashed' ? `1px dashed ${sc}` : `1px solid ${sc}` }} />
            )}
            <div className="flex-shrink-0 rounded-full flex items-center justify-center" style={{ backgroundColor: pc, width: showIcons ? 18 : 8, height: showIcons ? 18 : 8 }}>
              {showIcons && <Circle className="w-2.5 h-2.5 text-white" />}
            </div>
            <span className="text-xs font-medium truncate" style={{ color: tc }}>{item.title}</span>
          </div>
        );
      })}
    </div>
  );
};
